// eslint-disable-next-line import/prefer-default-export
export const supportedImportFileTypes = '.xls,.xlsx,.xlsb,.csv';
